//@ts-nocheck
import * as React from 'react';
import "./_styles/main.scss";
import { DialogContainer } from 'react-api-dialog';
import Header from './header/Header';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import { routeMap } from "./routes";
import { createHashHistory } from 'history';
// import { history } from "./Decorators";

class App extends React.Component {
    onScrollbarHide = (scrollbarWidth: number) => {
        const footers = Array.from(document.getElementsByClassName("footer"));
        footers.forEach((f: HTMLElement) => f.style.width = `calc(100% - ${scrollbarWidth}px)`);
    }
    onScrollbarShow = (scrollbarWidth: number) => {
        const footers = Array.from(document.getElementsByClassName("footer"));
        footers.forEach((f: HTMLElement) => f.style.removeProperty("width"));
    }
    render() {
        return (
            <div className="App">
                <DialogContainer historyFn={createHashHistory}
                    onScrollbarHide={this.onScrollbarHide}
                    onScrollbarShow={this.onScrollbarShow} />
                <Router>
                    <Header />
                </Router>
                <Router>
                    <Switch>
                        {routeMap.map(route => <Route key={route.path} path={route.path}
                            exact={true} component={route.component} />)}
                    </Switch>
                </Router>
            </div>
        );
    }
}

export default App;
